import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectClass {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectClass = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectClass) => {
  const itemList = useStoreState((state) => state.common.classList);
  const itemListFetch = useStoreActions((state) => state.common.fetchclassList);

  if (itemList === null) {
    itemListFetch();
  }
  
  const onSelect = (id) => {
    if (itemList) {
      const value = itemList.find((item) => item.id === id);
      onChange(value.id);
    }
  };





  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      className="classSelect"
      // allowClear
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      placeholder="Select Class"
      filterOption={(input, option:any) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.id} value={type.id}>
            {type.name}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Class</Option>
      )}
    </Select>
  );
};
